import { defineStore } from 'pinia'

import axios from "@axios"
import {reportError} from "@/plugins/misc"
import localforage from "localforage"

const baseUrl = `/happening/`

export const useHappeningsStore = defineStore({
  id: 'happening',
  state: () => ({
    // allHappenings: [  {_id:'1', restaurantName:"Violi", restaurantMarket:"Oak Brook, IL", name: "Violi Presents: Caymus Wine 4-Course Dinner Experience", imageId: "fb7cc100-2dc7-4556-bb65-89cf04d883df", date: "2024-02-13",  price: "$105 per ticket", url: "https://www.exploretock.com/violi-oak-brook/event/459285/violi-presents-caymus-wine-4-course-dinner-experience"},
    //     {_id:'2', name: "RPM Reserve Whiskey Event", restaurantName:"RPM Seafood", restaurantMarket:"Chicago, IL", imageId: "fb7cc100-2dc7-4556-bb65-89cf04d883df", date: "2024-02-02",  price: "$95 per person", url: "https://www.opentable.com/r/rpm-seafood-chicago"},],
    allHappenings: [],
    happeningsByRestaurant: {},

  }),
  actions: {

    async getHappenings() {
      try {
        let res = await axios.get(baseUrl, {
          params:{
          }
        })
        this.allHappenings = res.data
        localStorage.setItem('allHappenings', JSON.stringify(this.allHappenings))
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("stats.store.js:media", error.message, null,null,null, error)
      }
    },

    async getHappeningsByRestaurant(name, market) {
      try {
        let res = await axios.get(baseUrl, {
          params:{
            restaurantName:name,
            restaurantMarket:market
          }
        })
        if(!this.happeningsByRestaurant[market])
          this.happeningsByRestaurant[market] = {}
        this.happeningsByRestaurant[market][name] = res.data

        //localforage.setItem('justBookedReservationsByRestaurant', JSON.stringify(this.justBookedReservationsByRestaurant));
      } catch (error) {
        console.log("Error kF3")
        console.error(error)
        reportError("reservations.store.js:getHappeningsByRestaurant", error.message, null,null,null, error)
      }
    },

    async saveHappening(id) {
      let res
      try {
        let happeningToSave
        if(id){
          //find the happening
          happeningToSave = this.allHappenings.find(item => item.id === id)
        }else{
          happeningToSave = this.allHappenings.find(item => item.new)
        }

        if (happeningToSave?.new) {
          res = await axios.post(`${baseUrl}`, happeningToSave, {
            params: {
            }
          })
        } else {
          res = await axios.put(`${baseUrl}${happeningToSave.id}`, happeningToSave, {
            params: {
            }
          })
        }

        // var updateIndex = this.allHappenings.map(item => item.id).indexOf(happeningToSave._id);
        // Object.assign(this.allHappenings[updateIndex], experienceToSave)
        Object.assign(happeningToSave, res.data)

        await localStorage.setItem('allHappenings', JSON.stringify(this.allHappenings))
      } catch (error) {
        //reload page
        console.error(error)
        reportError("happening.store.js:saveHappening", error.message, null,null,null, error)

        //location.reload()
      }
      
      return res.data.id
    },

    async deleteHappening(happeningId) {
      try {
        let res = await axios.delete(baseUrl+'/'+happeningId, {
          params:{
          }
        })

        //delete item from media
        this.allHappenings = this.allHappenings.filter(item => item._id !== happeningId)
        localStorage.setItem('allHappenings', JSON.stringify(this.allHappenings))
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("stats.store.js:media", error.message, null,null,null, error)
      }
    },

  }
})
